



import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

import Assets from '@/constants/assets';
import Endpoints from '@/constants/endpoints';

import $http from '@/core/services/http.service';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

import { Convocation } from '@/manager/convocation/convocation.model';

@Component({
  components: {
    Icon,
  },
})
export default class CountDown extends Vue {
  private assets = Assets;
  private iconEnum = IconEnum;
  private convocationId!: string;
  private convocation = new Convocation();
  private nParticipants: number = 0;
  private timeLeft: string = '00:00:00';
  private convocationDate!: any;
  private isFinishCountDown: boolean = false;
  private incrementRegistereds: boolean = false;
  private isLastCall: boolean = true;
  private defaultsubtitleText: string = 'Toma asiento, empezamos en:';
  private subtitleText: string = this.defaultsubtitleText;

  get backgroundImg() {
    return {
      'background-image': `url("${this.assets.countDownBg}")`,
      'background-repeat': 'no-repeat',
      'background-size': 'cover',
      'background-position': 'center center',
    };
  }

  private created() {
    this.convocationId = this.$router.currentRoute.params.id;
    this.initializeClock();
    const callConvocationInterval = setInterval(() =>  {
      this.callGetConvocation(callConvocationInterval);
    }, 20000);
    this.callGetConvocation();
  }

  private initializeClock() {
    const count = setInterval(() =>  {
      this.isFinishCountDown = this.checkTimeFinished();
      if (! this.isFinishCountDown) {
        this.calculateCountDown();
      } else {
        this.isLastCall = false;
        this.getConvocation();
        clearInterval(count);
      }
    }, 1000);
  }

  private callGetConvocation(callConvocationInterval?: any) {
    if (! this.isFinishCountDown) {
      this.getConvocation();
    } else {
      clearInterval(callConvocationInterval);
    }
  }

  private getConvocation() {
    const scope = this;
    $http.get(`${Endpoints.convocation}${this.convocationId}/tv/`)
      .then((res) => {
        const data = res.data;
        if (this.isLastCall) {
          this.updateNParticipants(data.numberOfChecked);
        } else {
          this.countNParticipants(data.numberOfChecked);
        }
        // convocationDate is saved in UTC, but it refers to local time.
        // Need to adjust in odrder to compare with current time
        const tzOffset = Math.abs((new Date()).getTimezoneOffset());
        this.convocationDate = dayjs(data.hourOfStar).subtract(
          tzOffset,
          'minute',
        );
      });
  }

  private countNParticipants(nParticipants: number) {
    this.nParticipants = 0;
    const animationParticipants = setInterval(() =>  {
      if (this.nParticipants !== nParticipants) {
        this.nParticipants++;
      } else {
        clearInterval(animationParticipants);
      }
    }, 10);
  }

  private updateNParticipants(newVal: number) {
    if (!this.isFinishCountDown &&
        !this.incrementRegistereds &&
        this.nParticipants !== newVal) {
      this.incrementRegistereds = true;

      setTimeout(() => {
        this.nParticipants = newVal;
      }, 2000);

      setTimeout(() => {
        this.incrementRegistereds = false;
      }, 3000);
    }
  }

  private checkTimeFinished() {
    const currentDate = dayjs(new Date());
    return currentDate.isAfter(this.convocationDate);
  }

  private calculateCountDown() {
    const currentDate = dayjs(new Date());

    const hoursLeft = this.convocationDate.diff(currentDate, 'hour');
    this.subtitleText = this.defaultsubtitleText;

    if (hoursLeft < 24) {
      const minutesLeft = (this.convocationDate.diff(currentDate, 'minute') - Math.trunc(hoursLeft * 60));
      const secondsLeft =
        (this.convocationDate.diff(currentDate, 'second') - Math.trunc(minutesLeft * 60)
          - Math.trunc(hoursLeft * 60 * 60));

      const hoursLeftFormat = hoursLeft < 10 ? '0' + hoursLeft : hoursLeft;
      const minutesLeftFormat = minutesLeft < 10 ? '0' + minutesLeft : minutesLeft;
      const secondsLeftFormat = secondsLeft < 10 ? '0' + secondsLeft : secondsLeft;

      this.timeLeft = hoursLeftFormat + ':' + minutesLeftFormat + ':' + secondsLeftFormat;
    } else {
      const daysLeft = this.convocationDate.diff(currentDate, 'days');
      this.subtitleText = 'Estamos preparando este evento. Faltan:';
      if (daysLeft === 1) {
        this.timeLeft = daysLeft + ' día';
        this.subtitleText = 'Estamos preparando este evento. Falta:';
      } else {
        this.timeLeft = daysLeft + ' días';
      }
    }

  }
}
